<div card class="k-card">
  <div class="p-d-flex p-jc-between _header">
    <div class="_title p-d-flex p-ai-center">Zavisni troškovi</div>
    <div class="p-d-flex">
      <button
        pButton
        type="button"
        label="Prekalkuliši"
        class="p-button p-button-outlined"
        [disabled]="isPrekalkulisiDisabled"
        (click)="calculateZavisneTroskove()"
      ></button>
      <button
        class="p-ml-2"
        pButton
        type="button"
        label="Dodaj zavisne troškove"
        (click)="openTroskoviDialog()"
      ></button>
    </div>
  </div>
  <kodit-divider></kodit-divider>
  <div card-body>
    <div *ngIf="zavisniTroskovi.length === 0" class="p-d-flex p-jc-center p-ai-center" style="height: 100%">
      Nema zavisnih troškova
    </div>
    <div *ngIf="zavisniTroskovi.length > 0" class="p-d-flex p-flex-column" style="height: 100%">
      <h5>Stavke</h5>
      <!-- Table -->
      <div class="stavke">
        <!-- Header -->
        <div class="row header p-d-flex p-ai-center">
          <div class="cell naziv">Originalni broj računa</div>
          <div class="cell naziv">Naziv</div>
          <div class="cell cena">Cena bez PDV-a</div>
          <div class="cell cena">Cena sa PDV-om</div>
          <div class="cell right">Akcije</div>
        </div>

        <!-- Rows -->
        <div
          class="row p-d-flex p-ai-center"
          *ngFor="let s of zavisniTroskovi; let i = index"
        >
          <div class="cell naziv">{{ s.originalniBrojRacuna }}</div>
          <div class="cell naziv">{{ s.naziv }}</div>
          <div class="cell cena muted p-jc-end">
            {{ s.iznosBezPdv | currencyNumber: 'RSD' }}
          </div>
          <div class="cell cena">
            {{ s.iznosSaPdv | currencyNumber: 'RSD' }}
          </div>
          <i class="cell right pi pi-times p-error cursor-pointer" (click)="removeAt(i)"></i>
        </div>
      </div>
    </div>
  </div>
</div>
